import type { Subscriber } from '@setplex/tria-api'

export const updateProfileSwitchLocked = (
  subscriber: Subscriber | null,
  profileSwitchLocked: boolean
): Subscriber | null => {
  if (!subscriber) return null

  return {
    ...subscriber,
    profileSwitchLocked,
  }
}
